import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as cartActionCreators from '../../../actions/cart';
let allActionCreators = Object.assign({}, cartActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';

class DiamondStuds extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      price1: 380,
      price1a: 380,
      price2: 380,
      price3: 1300,

      carat1: '',
      carat1a: '',
      carat2: '',
      carat3: '',

      prong1: '',

      overrideImage1: false,
      overrideImage1a: false,
      overrideImage2: false,
      overrideImage3: false,

      errorCode: '',

      loadingButton: null,
    }
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getCW1() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.25 ctw',
        value: 380,
      },
      {
        display: '0.33 ctw',
        value: 550,
      },
      {
        display: '0.50 ctw',
        value: 850,
      },
      {
        display: '0.70 ctw',
        value: 1450,
      },
      {
        display: '1.00 ctw',
        value: 2500,
      },
      {
        display: '1.40 ctw',
        value: 4400,
      },
      {
        display: '2.00 ctw',
        value: 9500,
      },
    ];
  }

  getCW2() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.25 ctw',
        value: 380,
      },
      {
        display: '0.33 ctw',
        value: 600,
      },
      {
        display: '0.50 ctw',
        value: 1000,
      },
      {
        display: '0.70 ctw',
        value: 1750,
      },
      {
        display: '1.00 ctw',
        value: 3200,
      },
      {
        display: '1.40 ctw',
        value: 5800,
      },
      {
        display: '2.00 ctw',
        value: 11500,
      },
    ];
  }

  getCW3() {
    return [
      {
        display: 'Select Carat Weight',
        value: '',
      },
      {
        display: '0.50 ctw',
        value: 1300,
      },
      {
        display: '0.75 ctw',
        value: 1900,
      },
      // {
      //   display: '0.95 ctw',
      //   value: 2400,
      // },
      {
        display: '1.15 ctw',
        value: 4000,
      },
      {
        display: '1.50 ctw',
        value: 6000,
      },
      {
        display: '2.00 ctw',
        value: 12000,
      },
    ];
  }

  getProngs() {
    return [
      {
        display: 'Select Prongs',
        value: '',
      },
      {
        display: 'Three Prong',
        value: '3prong',
      },
      {
        display: 'Four Prong',
        value: '4prong',
      },
    ];
  }

  changeCarat1(evt) {
    this.setState({ 
      carat1: evt.target.value,
      overrideImage1: false,
      }, () => {
      if(this.state.errorCode == 'carat1') {
        this.setState({ errorCode: ''});
      }
    });
  }

  changeCarat1a(evt) {
    this.setState({ 
      carat1a: evt.target.value,
      overrideImage1a: false,
      }, () => {
      if(this.state.errorCode == 'carat1a') {
        this.setState({ errorCode: ''});
      }
    });
  }

  changeCarat2(evt) {
    this.setState({ 
      carat2: evt.target.value,
      overrideImage2: false,
      }, () => {
      if(this.state.errorCode == 'carat2') {
        this.setState({ errorCode: ''});
      }
    });
  }

  changeCarat3(evt) {
    this.setState({ 
      carat3: evt.target.value,
      overrideImage3: false,
      }, () => {
      if(this.state.errorCode == 'carat3') {
        this.setState({ errorCode: ''});
      }
    });
  }

  changeProng(evt) {
    this.setState({ prong1: evt.target.value });
  }

  getCaratWeight(sku, price) {
    if(!sku) {
      return '';
    }

    let dataBlock = [];

    switch(sku) {
      case 'DSTRD':
        dataBlock = this.getCW1();
        break;
      case 'DSTRD4':
        dataBlock = this.getCW1();
        break;
      case 'DSTPS':
        dataBlock = this.getCW2();
        break;
      case 'DSTHA':
        dataBlock = this.getCW3();
        break;
    }

    for(let i = 0; i < dataBlock.length; i++) {
      if(dataBlock[i].value == price) {
        return dataBlock[i].display;
      }
    }
    return '';
  }

  getStudsDesc(sku, price) {

    // Diamond stud earrings (INTERNAL NOTE FOR WEST: for Round or Princess only)  
    // Shape:
    // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
    // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all studs will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
    // Color: The average color range for studs is I – J
    // Clarity: The average clarity range for studs is SI2 - I1
     

    // Round Halo stud earrings
    // Carat Weight:  (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)
    // Metal type: 14 karat white gold (INTERNAL NOTE FOR WEST: all studs will be in 14 karat white gold, special requests will be noted elsewhere for the time being)
    // Color: The average color range for studs is I – J
    // Clarity: The average clarity range for studs is SI2 - I1

    let diaDesc = '';
    let colorString = 'H - I';
    let clarityString = 'I1';

    if(sku == 'DSTRD' || sku == 'DSTRD4') {
      diaDesc += '<B>Shape</B>: Round<br />';
      colorString = 'I - J';
      clarityString = 'I1';
    } else if(sku == 'DSTPS') {
      diaDesc += '<B>Shape</B>: Princess<br />';
      colorString = 'G - H';
      clarityString = 'VS - SI';
    }

    let caratWeight = this.getCaratWeight(sku, price);
    if(caratWeight) {
      diaDesc += ('<B>Carat Weight</B>: ' + caratWeight + ' (NOTE: The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%)<br />');
    }

    diaDesc += ('<B>Metal type</B>: 14 karat white gold<br /><B>Color</B>: The average color range for studs is ' + colorString + '<br /><B>Clarity</B>: The average clarity range for studs is ' + clarityString);
    return diaDesc;
  }

  getStudImage(studCaratCost) {

    if(!studCaratCost || this.state.overrideImage1) {
      return <img src='https://ddw2.diamondsdirect.com/img/diamondpages/products2/three_prong_studs.jpg' />;
    }

    return <img src='https://ddw2.diamondsdirect.com/img/diamondpages/newear.svg' />;
  }

  getStud4Image(studCaratCost) {

    if(!studCaratCost || this.state.overrideImage1a) {
      return <img src='https://ddw2.diamondsdirect.com/img/diamondpages/products2/four_prong_studs.jpg' />;
    }

    return <img src='https://ddw2.diamondsdirect.com/img/diamondpages/newear.svg' />;
  }

  getDiamondImageStyle(studCaratCost, suffix) {

    const stateKey = `overrideImage${suffix}`;

    if(!studCaratCost || this.state[stateKey]) {
      return {};
    }

    // ear-width: 700px
    // image-width: 2000

    // 1mm = 1.4%

    const builtStyles = {
      display: 'block',
    };

    let caratWeight = null;

    switch(parseInt(studCaratCost)) {
      case 380:
        caratWeight = 0.25;
        break;
      case 550:
        caratWeight = 0.33;
        break;
      case 850:
        caratWeight = 0.50;
        break;
      case 1450:
        caratWeight = 0.70;
        break;
      case 2500:
        caratWeight = 1.00;
        break;
      case 4400:
        caratWeight = 1.40;
        break;
      case 9500:
        caratWeight = 2.00;
        break;
      default:
        break;
    }

    const diamondWidth = this.getDiamondSize(caratWeight);

    builtStyles.width = diamondWidth.toString() + '%';
    builtStyles.height = diamondWidth.toString() + '%';
    builtStyles.top = (82 - diamondWidth/2).toString() + '%'; // Stud center: 82%
    builtStyles.left = (60 - diamondWidth/2).toString() + '%'; // Stud center 60%

    return builtStyles;
  }

  // Returns double of size
  getDiamondSize(caratWeight) {

    // Image width: (used jpg) 2000px;
    // Ear diameter: 700px;

    // let earWidth = 25.0mm;
    // let oneCtWidth = 6.5mm;

    // d = 6.5(cw)^1.5

    // 6.5 = a(cw)^(2/3)

    // 2r

    // 4/3 pi r^3 = cw


    // 0.75*cw = pi r^3

    // 2(0.25*cw)^1/3 = 2r


    let widthMM = 6.5 * Math.pow(caratWeight, 0.33333333);

    // 1mm = 1.4%    
    return (widthMM * 1.4);
  }

  getDiamondRadius() {
    let widthMM = 6.5 * Math.pow(caratWeight, 0.33333333);
    return ((widthMM * 1.4)/2);
  }

  addToCart(sku, caratPrice, code) {
    
    if(!caratPrice) {
      this.setState({ errorCode: code });
      return;
    }

    this.setState({ loadingButton: code });

    // export function cartAddDiamondJewelry(stockNo, sku, carat_mod, diamond_desc) {
    this.props.cartAddDiamondJewelry(sku, caratPrice, this.getStudsDesc(sku, caratPrice))
    .then((resp) => {
      console.log(resp);
      this.externalNav('checkout/cart');
    })
    .catch((errResp) => {
      this.setState({ loadingButton: null });
    });
  }

  getToggleStyle(orderPrice, suffix) {
    if(!orderPrice) {
      return {};  
    } else {
      return {
        display: 'block',
      }
    }
  }

  toggleImageOverride(suffix) {

    const stateKey = `overrideImage${suffix}`;

    this.setState({ [stateKey]: !this.state[stateKey] });
  }

  render() {
    return <div className={'DiamondStuds DiamondPage'}>
      <div className='dpBreadcrumbs'>Diamond Studs</div>
      <div className='dpProductsWrapper'>

        <div className='dpRowWrapper'>

          <div className='dpProduct'>
            <div className='dpItemWrapper'>
              <div className={'dpProductImg studSizing'}>
                {this.getStudImage(this.state.carat1)}
                <div className='diamondPositioning' style={this.getDiamondImageStyle(this.state.carat1, '1')}></div>
                <div className='imageToggle' style={this.getToggleStyle(this.state.carat1, '1')} onClick={() => this.toggleImageOverride('1')}>
                  <i className="fas fa-exchange-alt"></i>
                </div>
              </div>
              <div className='dpProductTitle'>Round Three-Prong Studs</div>
              <div className='dpProductConfigElement'>
                {this.state.errorCode == 'carat1' ?
                  <div className='dpErrorMessage'>Please select a carat weight</div> :
                  null
                }
                <RhinoSelect
                  options={this.getCW1()}
                  value={this.state.carat1}
                  changeMethod={::this.changeCarat1}
                  rootClass='productSelect' />
              </div>
              <div className='dpProductConfigElement' style={{display: 'none'}}>
                <RhinoSelect
                  options={this.getProngs()}
                  value={this.state.prong1}
                  changeMethod={::this.changeProng}
                  rootClass='productSelect' />
              </div>
              <div className='dpBr'></div>
              <div className='dpPrice'>${(this.state.carat1 ? this.state.carat1 : this.state.price1).toLocaleString()}</div>
              {this.state.loadingButton == 'carat1' ?
                <div className={'dpAddToCartAAA dpLoading'}><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
                <div className='dpAddToCart' onClick={() => this.addToCart('DSTRD', this.state.carat1, 'carat1')}><div>Add to Cart</div></div>
              }
            </div>
          </div>

          <div className='dpProduct'>
            <div className='dpItemWrapper'>
              <div className={'dpProductImg studSizing'}>
                {this.getStud4Image(this.state.carat1a)}
                <div className='diamondPositioning' style={this.getDiamondImageStyle(this.state.carat1a, '1a')}></div>
                <div className='imageToggle' style={this.getToggleStyle(this.state.carat1a, '1a')}  onClick={() => this.toggleImageOverride('1a')}>
                  <i className="fas fa-exchange-alt"></i>
                </div>
              </div>
              <div className='dpProductTitle'>Round Four-Prong Studs</div>
              <div className='dpProductConfigElement'>
                {this.state.errorCode == 'carat1a' ?
                  <div className='dpErrorMessage'>Please select a carat weight</div> :
                  null
                }
                <RhinoSelect
                  options={this.getCW1()}
                  value={this.state.carat1a}
                  changeMethod={::this.changeCarat1a}
                  rootClass='productSelect' />
              </div>
              <div className='dpProductConfigElement' style={{display: 'none'}}>
                <RhinoSelect
                  options={this.getProngs()}
                  value={this.state.prong1}
                  changeMethod={::this.changeProng}
                  rootClass='productSelect' />
              </div>
              <div className='dpBr'></div>
              <div className='dpPrice'>${(this.state.carat1a ? this.state.carat1a : this.state.price1a).toLocaleString()}</div>
              {this.state.loadingButton == 'carat1a' ?
                <div className={'dpAddToCartAAA dpLoading'}><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
                <div className='dpAddToCart' onClick={() => this.addToCart('DSTRD4', this.state.carat1a, 'carat1a')}><div>Add to Cart</div></div>
              }
            </div>
          </div>
        </div>

        <div className='dpRowWrapper'>
          <div className='dpProduct'>
            <div className='dpItemWrapper'>
              <div className='dpProductImg'>
                <img src='https://ddw2.diamondsdirect.com/img/diamondpages/products2/princess_studs.jpg' />
              </div>
              <div className='dpProductTitle'>Princess Studs</div>
              <div className='dpProductConfigElement'>
                {this.state.errorCode == 'carat2' ?
                  <div className='dpErrorMessage'>Please select a carat weight</div> :
                  null
                }
                <RhinoSelect
                  options={this.getCW2()}
                  value={this.state.carat2}
                  changeMethod={::this.changeCarat2}
                  rootClass='productSelect' />
              </div>
              <div className='dpBr'></div>
              <div className='dpPrice'>${(this.state.carat2 ? this.state.carat2 : this.state.price2).toLocaleString()}</div>
              {this.state.loadingButton == 'carat2' ?
                <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
                <div className='dpAddToCart' onClick={() => this.addToCart('DSTPS', this.state.carat2, 'carat2')}><div>Add to Cart</div></div>
              }
            </div>
          </div>

          <div className='dpProduct'>
            <div className='dpItemWrapper'>
              <div className='dpProductImg'>
                <img src='https://ddw2.diamondsdirect.com/img/diamondpages/products2/halo_studs.jpg' />
              </div>
              <div className='dpProductTitle'>Round Halo Studs</div>
              <div className='dpProductConfigElement'>
                {this.state.errorCode == 'carat3' ?
                  <div className='dpErrorMessage'>Please select a carat weight</div> :
                  null
                }
                <RhinoSelect
                  options={this.getCW3()}
                  value={this.state.carat3}
                  changeMethod={::this.changeCarat3}
                  rootClass='productSelect' />
              </div>
              <div className='dpBr'></div>
              <div className='dpPrice'>${(this.state.carat3 ? this.state.carat3 : this.state.price3).toLocaleString()}</div>
              {this.state.loadingButton == 'carat3' ?
                <div className='dpAddToCart dpLoading'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
                <div className='dpAddToCart' onClick={() => this.addToCart('DSTHA', this.state.carat3, 'carat3')}><div>Add to Cart</div></div>
              }
            </div>
          </div>
        </div>
      </div>
      <div className='dpLegal'>*Please note: All diamond studs are set in 14 karat white gold.<br />The average color range for round studs is I - J and the average clarity range I1.<br />The average color range for princess studs is G – H and the clarity range is VS-SI.<br />The average color range for round halo studs is H-I and average clarity is I1.<br />Please chat in or <a href='/contact-us'>contact us</a> to purchase studs of a different quality.<br />The total carat weight displayed may represent a range, actual total carat weight may vary up to 5%.</div>
      <div className='studsCustomSection'>
        <div className='scWrapper'>
          <div className='studsCustomLeft'>
            <img src='https://ddw2.diamondsdirect.com/img/diamondpages/studs_icon.svg' />
          </div>
          <div className='studsCustomRight'>
            <div className='scTitle'>Custom Studs</div>
            <div className='scBody'>Diamonds Direct can handcraft diamond studs to meet any expectations! For certified diamonds, fancy colors, or fancy shape diamonds our diamond experts can help select diamond to make the perfect pair of earrings.</div>
            <div className='scButtonWrapper' onClick={() => this.internalNav('custom-design')}>
              <div className='scButton'>Create Custom</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
	}
}
export default DiamondStuds;

function mapStateToProps(state) {
  return {

  };
}

export const DiamondStudsContainer = connect(
  mapStateToProps,
  allActionCreators
)(DiamondStuds);


// WEBPACK FOOTER //
// ./src/components/views/diamondpages/DiamondStuds.jsx